import { render, staticRenderFns } from "./ChatBoxWidget.vue?vue&type=template&id=e974e0ce&scoped=true&"
import script from "./ChatBoxWidget.vue?vue&type=script&lang=js&"
export * from "./ChatBoxWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxWidget.vue?vue&type=style&index=0&id=e974e0ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e974e0ce",
  null
  
)

export default component.exports